export default __webpack_public_path__ + "static/useCaseBg-57feed27e200101282ee34b31c1e682f.png";